// extracted by mini-css-extract-plugin
export default {"videoLinks":"GroupWords_videoLinks__ZFCPz"};